import { createOrUpdateMicroCompetency, makeCopy, unlockMicroCompetencyForUsers, loadMicroCompetencyUnlockFor, saveMicroCompetencyPrereqs, publishOneMicroCompetency, curateMicroCompetency, publishMultipleMicroCompetencies, deleteMultipleMicroCompetencies, getMicrocompetencies, getMicroCompetencyDetail, getMicroCompetencyAssets, getMicroCompetencySubjects, getMicroCompetencyModules , updateChildMicroCompetencies} from '../api'

export const createMicroCompetency = ({ state, commit }, data) => {
  return createOrUpdateMicroCompetency(data)
}

export const updateMicroCompetencyChildren = ({ state, commit }, uuid) => {
  return updateChildMicroCompetencies(uuid)
}
export const createCopy = ({ state, commit }, uuid) => {
  return makeCopy(uuid)
}

export const loadMicroCompetencyDetail = ({ state, commit }, uuid) => {
  return getMicroCompetencyDetail(uuid)
}

export const loadMicroCompetencyAssets = ({ state, commit }, uuid) => {
  return getMicroCompetencyAssets(uuid)
}
export const loadMicrocompetencies = ({ state, commit }, { page, count, title, published }) => {
  return getMicrocompetencies(page, count, title, published)
}

export const deleteMicroCompetencies = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleMicroCompetencies(itemsToDelete)
}
export const getMicroCompetencyUnlockFor = ({ state, commit }, uuid) => {
  return loadMicroCompetencyUnlockFor(uuid)
}

export const unlockMicroCompetency = ({ state, commit }, {mcId, selectionType, userIds}) => {
  return unlockMicroCompetencyForUsers(mcId, selectionType, userIds)
}

export const publishMicroCompetencies = ({ state, commit }, {items, flag}) => {
  return publishMultipleMicroCompetencies(items, flag)
}
export const curateMicroCompetencyPlan = ({ state, commit },data ) => {
    return curateMicroCompetency(data).then((res) => {
        return res
    })
}
export const updateMicroCompetencyPrereqs = ({ state, commit },data ) => {
    return saveMicroCompetencyPrereqs(data).then((res) => {
        return res
    })
}

export const publishMicroCompetency = ({ state, commit }, uuid) => {
  return publishOneMicroCompetency(uuid)
}

export const loadMicroCompetencySubjects = ({ state, commit }) => {
  return getMicroCompetencySubjects()
}

export const loadMicroCompetencyModules = ({ state, commit }) => {
  return getMicroCompetencyModules()
}



// WEBPACK FOOTER //
// ./src/app/microCompetency/vuex/actions.js